import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { authApi } from "@/api/auth";
import { ensureSession } from "@/auth/session";
import { useSessionStore } from "@/stores/session";

/**
 * Pathless layout for every authenticated screen. Adds no URL segment.
 * `beforeLoad` blocks until we know whether the user is signed in; in the
 * backend's open mode `/auth/me` returns a synthetic user so this passes.
 */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ location }) => {
    await ensureSession();
    if (!useSessionStore.getState().user) {
      const { needsSetup } = await authApi.setupStatus();
      if (needsSetup) throw redirect({ to: "/setup" });
      throw redirect({ to: "/login", search: { redirect: location.pathname } });
    }
  },
  component: AppShell,
});
